import { render } from "./InfoModal.vue?vue&type=template&id=70c807ba&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-70c807ba"

export default script